module.exports = __webpack_public_path__ + "static/media/user-check.aa5c40fa.svg";